<template>
    <v-app id="selectLanguage">
        <tool-bar>
            <slot><h3>{{arrivalDepartureCertification.type === 'arrival'?'Arrival':'Departure'}} Certification</h3>
            </slot>
        </tool-bar>
        <v-content class="pt-0">
            <v-container fluid>
                <v-layout justify-center>
                    <v-card>
                        <v-toolbar class="elevation-0" color="none">
                            <v-toolbar-title>
                                <b class="text-primary">Dear {{extendConvertVisaDetail.full_name}} , please confirm your
                                    information:</b>
                            </v-toolbar-title>
                            <v-spacer/>
                        </v-toolbar>

                        <v-card-text class="pt-0">
                            <v-layout row wrap>
                              <form-error-display-handler :errors="errors"></form-error-display-handler>
                                <confirmation-header-text
                                    :icon="arrivalDepartureCertification.type === 'arrival'?'mdi-alpha-a-box':'mdi-alpha-d-box'"
                                    :text="(arrivalDepartureCertification.type === 'arrival'?'Arrival ':'Departure ')+$vuetify.lang.t('$vuetify.certification_details')"
                                    class="ml-2"/>

                                <v-flex sm4 xs12>
                                    <list-item-detail
                                        :sub_title="office"
                                        :title="arrivalDepartureCertification.type === 'arrival'?$vuetify.lang.t('$vuetify.arrived_from'):$vuetify.lang.t('$vuetify.departure_from')"/>
                                </v-flex>
                                <v-flex sm4 xs12>
                                    <list-item-detail
                                        :sub_title="arrived_country"
                                        :title="arrivalDepartureCertification.type === 'arrival'?$vuetify.lang.t('$vuetify.arrived_from_country'):$vuetify.lang.t('$vuetify.departure_country')"/>
                                </v-flex>
                                <v-flex sm4 xs12>
                                    <list-item-detail
                                        :sub_title="arrivalDepartureCertification.date"
                                        :title="arrivalDepartureCertification.type === 'arrival'?$vuetify.lang.t('$vuetify.arrived_at'):$vuetify.lang.t('$vuetify.departure_at')"/>

                                </v-flex>
                                <v-flex xs12 sm4 v-if="arrivalDepartureCertification.type === 'arrival'">
                                    <list-item-detail :sub_title="arrivalDepartureCertification.purpose_of_visit"
                                                      :title="$vuetify.lang.t('$vuetify.purpose_of_visit')"/>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <list-item-detail :sub_title="arrivalDepartureCertification.cost"
                                                      :title="$vuetify.lang.t('$vuetify.total_cost')"/>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <list-item-detail
                                        :sub_title="arrivalDepartureCertification.reason_for_certification"
                                        :title="$vuetify.lang.t('$vuetify.reason_for_certification')"/>
                                </v-flex>


                                <v-flex xs12>
                                    <v-divider class="mt-3"/>
                                </v-flex>

                                <v-flex xs12>
                                    <visa-detail :visa="extendConvertVisaDetail"/>
                                </v-flex>

                                <v-flex xs12>
                                    <v-divider class="my-3"/>
                                </v-flex>

                                <v-flex xs12>
                                    <v-btn :loading="loading" @click="submit" class="pull-right mr-2" color="primary "
                                           large>
                                        Submit
                                    </v-btn>
                                    <v-btn
                                            @click="backBtnClicked()"
                                            class="pull-right mr-2"
                                            color="error"
                                            large>
                                        {{$vuetify.lang.t('$vuetify.back')}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import VisaDetail from "../VisaDetail";
    import ListItemDetail from "../../components/ListItemDetail";
    import ToolBar from "../../components/ToolBar";
    import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
    import FileListItemDetail from "../../components/FileListItemDetail";
    import FormErrorDisplayHandler from "@/components/FormErrorDisplayHandler";

    export default {
        name: "ArrivalDepartureCertificationConfirm",
      data(){
          return{
            errors:[]
          }
      },
        components: {
          FormErrorDisplayHandler,
            VisaDetail,
            ListItemDetail, ToolBar, ConfirmationHeaderText, FileListItemDetail
        },
        computed: {
            ...mapGetters('VisaSingle', ['visa', 'arrivalDepartureCertification', 'extendConvertVisaDetail', 'loading']),
            office() {
                let office = this.$store.state.Office.offices.find((i) => i.id === this.arrivalDepartureCertification.office);
                return office.name;
            },
            arrived_country() {
                let country = this.$store.state.CountryForTouristList.all.find((i) => i.id === this.arrivalDepartureCertification.country);
                return country.country_name;
            }

        },
        methods: {
            ...mapActions({
                submitArrivalCertification: 'VisaSingle/submitArrivalCertification'
            }),
            submit() {
                this.submitArrivalCertification().then((res) => {
                    this.$store.commit("VisaSingle/resetState");
                    this.$store.commit('VisaSingle/setPrintResponse', res.data);
                    this.$router.push({
                        name: 'PrintForm'
                    })
                }).catch((err)=>{
                  this.errors = err.response.data.errors;
                })
            },
            backBtnClicked() {
                this.$router.go(-1);
            },
        }
    }
</script>
